import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    integrations: []
  },
  mutations: {
    set(state, integrations) {
      state.integrations = integrations;
    }
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/integration.js